import { render } from "./ViewFileDialog.vue?vue&type=template&id=086a7c82"
import script from "./ViewFileDialog.vue?vue&type=script&lang=js"
export * from "./ViewFileDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__